var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "#F5F9FC",
    stroke: "#E2E7EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2999 25.4C22.0238 25.4 21.7999 25.1761 21.7999 24.9V18.1C21.7999 17.8238 22.0238 17.6 22.2999 17.6H23.0999C23.376 17.6 23.5999 17.8238 23.5999 18.1V24.9C23.5999 25.1761 23.376 25.4 23.0999 25.4H22.2999ZM28.5999 25.4C28.3238 25.4 28.0999 25.1761 28.0999 24.9V18.1C28.0999 17.8238 28.3238 17.6 28.5999 17.6H29.3999C29.676 17.6 29.8999 17.8238 29.8999 18.1V24.9C29.8999 25.1761 29.676 25.4 29.3999 25.4H28.5999ZM19.8999 28.4C19.6238 28.4 19.3999 28.1761 19.3999 27.9V27.1C19.3999 26.8238 19.6238 26.6 19.8999 26.6H38.0999C38.376 26.6 38.5999 26.8238 38.5999 27.1V27.9C38.5999 28.1761 38.376 28.4 38.0999 28.4H19.8999ZM34.8999 25.4C34.6238 25.4 34.3999 25.1761 34.3999 24.9V18.1C34.3999 17.8238 34.6238 17.6 34.8999 17.6H35.6999C35.976 17.6 36.1999 17.8238 36.1999 18.1V24.9C36.1999 25.1761 35.976 25.4 35.6999 25.4H34.8999ZM19.8999 16.4C19.6238 16.4 19.3999 16.1761 19.3999 15.9V14.309C19.3999 14.1196 19.5069 13.9465 19.6763 13.8618L28.7763 9.31175C28.9171 9.24137 29.0827 9.24137 29.2235 9.31175L38.3235 13.8618C38.4929 13.9465 38.5999 14.1196 38.5999 14.309V15.9C38.5999 16.1761 38.376 16.4 38.0999 16.4H19.8999ZM24.127 13.6524C23.6544 13.8878 23.8219 14.6 24.35 14.6H33.6498C34.1779 14.6 34.3454 13.8878 33.8728 13.6524L29.2228 11.336C29.0824 11.2661 28.9174 11.2661 28.777 11.336L24.127 13.6524Z",
    fill: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccount);
export default __webpack_public_path__ + "static/media/bank-account.7da9c48058cd6f156a741812be49ed06.svg";
export { ForwardRef as ReactComponent };